import { ObjectiveStateResourceType } from '../ObjectiveState';
import ballotDisplayOrder from './constants/ballotDisplayOrder';
import { OneBallotResourceType } from './One';

export let getIsBallotComplete = ({
  ballot,
  ballotShape,
}: {
  ballot: OneBallotResourceType;
  ballotShape: ObjectiveStateResourceType['ballotShape'];
}) =>
  Boolean(Object.values(ballotShape || {}).filter(Boolean).length) &&
  Object.values(ballot || {}).filter(Boolean).length ===
    Object.keys(ballotShape).length;

export let getRemainingCategories = ({
  ballot,
  ballotShape,
}: {
  ballot: OneBallotResourceType;
  ballotShape: ObjectiveStateResourceType['ballotShape'];
}) =>
  Object.keys(ballotShape).length -
  Object.values(ballot || {}).filter(Boolean).length;

export let getIncompleteCategoryKeys = ({
  ballot,
  ballotShape,
}: {
  ballot: OneBallotResourceType;
  ballotShape: ObjectiveStateResourceType['ballotShape'];
}) => ballotDisplayOrder.filter(categoryKey => !ballot?.[categoryKey]);

export let getCompleteCategoryKeys = ({
  ballot,
  ballotShape,
}: {
  ballot: OneBallotResourceType;
  ballotShape: ObjectiveStateResourceType['ballotShape'];
}) => ballotDisplayOrder.filter(categoryKey => ballot?.[categoryKey]);

export let getHasStartedBallot = (ballot: OneBallotResourceType) =>
  Boolean(Object.values(ballot || {}).filter(Boolean).length);
